import fileSys from "../../fileoprators/fileSystem";
import { INVALID_1000 } from "../../shared/consts";
import { isDefined } from "../shared";
import { isNumber, isString, logTime } from "../../shared/utils";
import CalCaseDebug from "./CalCaseDebug";

const addonDT = window.__ct__.debug
  ? CalCaseDebug
  : window.require(fileSys.getUtilPath("DEA520Data.node"));

const INVALID_STR = "--";
const RANGE_IN_COLOR = "lightgreen";
const RANGE_OUT_COLOR = "red";
const MIN_VALID_VAL = 500;

function getValidVal(val, delta) {
  if (val === INVALID_1000) {
    return val;
  } else {
    return val / delta;
  }
}
export function MwGetXYZPoints(imgPtr, w, h, isLocalImg, CHANELS = 4) {
  if (!global.netPtr) {
    let netrout = fileSys.getUtilPath("cen_v3_pnt_520.mnn");
    let alloc = addonDT.MallocNetPtr(netrout);
    if (alloc.result === 0) global.netPtr = alloc.ptr;
  }
  if (!global.netPtr) {
    return false;
  }

  let roicentxyr = new Float64Array(4);
  let delta = isLocalImg ? 2 : 1;
  roicentxyr[0] = parseFloat(window.calibSettings.CenterPoint.x) * delta;
  roicentxyr[1] = parseFloat(window.calibSettings.CenterPoint.y) * delta;
  roicentxyr[2] = window.calibSettings.Roi.r * delta;
  roicentxyr[3] = window.calibSettings.Roi.focusLimit;
  let xypos = new Float64Array(2);
  let zpos = new Float64Array(3);
  xypos.fill(INVALID_1000);
  zpos.fill(INVALID_1000);
  // console.log(
  //   `in:${roicentxyr[0]},${roicentxyr[1]},${roicentxyr[2]},${roicentxyr[3]}`
  // )
  // logTime('start MwGetXYZPoints')
  let result = addonDT.MwGetXYZPoints(
    imgPtr,
    w,
    h,
    CHANELS,
    roicentxyr.buffer,
    global.netPtr,
    xypos.buffer,
    zpos.buffer
  );
  // logTime('end MwGetXYZPoints')
  // console.log(
  //   `result:${result.result},xy:{${xypos[0]},${xypos[1]}}, z:{${zpos[0]},${zpos[1]}}`
  // )
  return {
    result: result.result,
    xy: { x: getValidVal(xypos[0], delta), y: getValidVal(xypos[1], delta) },
    z: {
      x: getValidVal(zpos[0], delta),
      y: getValidVal(zpos[1], delta)
    }
  };
}

export function getCTOffset(xypos, zpos) {
  if (!xypos || !zpos) {
    return null;
  }
  let centerXY = window.ctShotInfo.centerPoint;
  let offsetX = window.ctShotInfo.autoShot.offsetX;
  let offsetY = window.ctShotInfo.autoShot.offsetY;
  let offsetZ = window.ctShotInfo.autoShot.offsetZ;
  let caledxyz = {
    x: xypos.x - centerXY.x,
    y: xypos.y - centerXY.y,
    z: zpos.x - centerXY.x
  };
  // this.ctCaledOffset = { x: xypos.x - centerXY.x, y: xypos.y - centerXY.y, z: Math.sqrt(Math.pow(zpos.x - centerXY.x, 2) + Math.pow(zpos.y - centerXY.y, 2)) }
  if (xypos.x === INVALID_1000) {
    caledxyz.x = INVALID_1000;
    caledxyz.z = INVALID_1000;
  }
  if (xypos.y === INVALID_1000) {
    caledxyz.y = INVALID_1000;
  }
  if (zpos.x === INVALID_1000 || zpos.y === INVALID_1000) {
    caledxyz.z = INVALID_1000;
  }
  caledxyz.xok = xypos && Math.abs(caledxyz.x) <= offsetX;
  caledxyz.yok = xypos && Math.abs(caledxyz.y) <= offsetY;
  caledxyz.zok = xypos && zpos && Math.abs(caledxyz.z) <= offsetZ;
  return caledxyz;
}

export function getOffsetShown(ctCaledOffset) {
  let tmp = ctCaledOffset;
  let x;
  let y;
  let z;
  if (!isDefined(tmp) || !isDefined(tmp.x) || !isDefined(tmp.y)) {
    x = y = z = INVALID_STR;
    return {
      x: { label: x, isPosNum: false, color: RANGE_OUT_COLOR },
      y: { label: y, isPosNum: false, color: RANGE_OUT_COLOR },
      z: { label: z, isPosNum: false, color: RANGE_OUT_COLOR }
    };
  } else {
    x =
      isNumber(tmp.x) && !isNaN(tmp.x)
        ? tmp.x === INVALID_1000 || Math.abs(tmp.x) > MIN_VALID_VAL
          ? INVALID_STR
          : tmp.x._toFixed(0)
        : INVALID_STR;
    y =
      isNumber(tmp.y) && !isNaN(tmp.y)
        ? tmp.y === INVALID_1000 || Math.abs(tmp.y) > MIN_VALID_VAL
          ? INVALID_STR
          : tmp.y._toFixed(0)
        : INVALID_STR;
    z =
      isNumber(tmp.z) && !isNaN(tmp.z)
        ? tmp.z === INVALID_1000 || Math.abs(tmp.z) > MIN_VALID_VAL
          ? INVALID_STR
          : tmp.z._toFixed(0)
        : INVALID_STR;
  }
  return {
    x: {
      label: x,
      isPosNum: x !== INVALID_STR ? tmp.x >= 0 : false,
      color: tmp.xok ? RANGE_IN_COLOR : RANGE_OUT_COLOR
    },
    y: {
      label: y,
      isPosNum: y !== INVALID_STR ? tmp.y >= 0 : false,
      color: tmp.yok ? RANGE_IN_COLOR : RANGE_OUT_COLOR
    },
    z: {
      label: z,
      isPosNum: z !== INVALID_STR ? tmp.z >= 0 : false,
      color: tmp.zok ? RANGE_IN_COLOR : RANGE_OUT_COLOR
    }
  };
}

export function getCTCenterOffsetInfo(buf, w, h, chanels = 4) {
  let isLocalImg = isString(buf);
  let tmp = isLocalImg ? buf : buf.buffer;
  let result = MwGetXYZPoints(tmp, w, h, isLocalImg, chanels);
  let xypos;
  let zpos;
  if (!isDefined(result) || result.result !== 0) {
    xypos = zpos = null;
  } else {
    xypos = result.xy;
    zpos = result.z;
  }

  let offsetxyz = getCTOffset(xypos, zpos);
  let offsetstr = getOffsetShown(offsetxyz);
  let inrange = isDefined(offsetxyz) && offsetxyz.xok && offsetxyz.yok && offsetxyz.zok;
  return {
    xyz: { xypos, zpos },
    offsetxyz,
    offsetstr,
    inrange
  };
}



// WEBPACK FOOTER //
// ./src/topography/js/CalCenter.js